"use client";
import React from "react";
import Image from "next/image";
import Link from "next/link";
import useSearchCourses from "@/hook/useSearchCourses";
import { Input } from 'antd';
import { FiSearch } from "react-icons/fi";

export default function SearchBarDesktop() {
  const {
    searchText,
    setSearchText,
    suggestions,
    setSuggestions,
    showDropdown,
    setShowDropdown,
    wrapperRef,
    handleInputChange,
  } = useSearchCourses();
  const { Search } = Input;

  return (
    <div className="relative mx-auto xl:mx-0 hidden md:block" ref={wrapperRef}>
      <form className="search-box" onSubmit={(e) => e.preventDefault()}>
        <input
          type="text"
          placeholder="কোর্স সার্চ করুন"
          className="search-input hidden md:inline-block"
          value={searchText}
          onChange={handleInputChange}
        />
        <button type="submit" className="search-button">
          <FiSearch/>
        </button>
        {/* <Search className="search-input hidden md:!flex" placeholder="কোর্স সার্চ করুন" value={searchText} onChange={handleInputChange} enterButton /> */}
      </form>

      {showDropdown && suggestions.length > 0 && (
        <div className="absolute z-50 w-full bg-fill-white border border-gray-border mt-2 rounded shadow">
          {suggestions.map((course, index) => (
            <Link
              href={`/course/${course.slug}`}
              key={index}
              className="flex items-center p-2 hover:bg-fill-soft-1 text-primary-text"
              onClick={() => {
                setSearchText("");
                setSuggestions([]);
                setShowDropdown(false);
              }}
            >
              {course.thumbnail && (
                <Image
                  src={course.thumbnail}
                  alt={course.title}
                  width={40}
                  height={40}
                  className="rounded object-cover mr-2"
                />
              )}
              <span className="text-sm ">{course.title}</span>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
